module.exports = __webpack_public_path__ + "img/featureImg4.34683746.png";